import React, { useState } from "react";
import {
  TitleContainer,
  TitleText,
  SubtitleText,
  TitleTextHolder,
  PaymentLinkContainer,
  PaymentLinkHeader,
  TitleSearchContainer,
  PaymentLinkTitleText,
  FilterContainer,
  CalendarTextHolder,
  CalendarText,
  CalendarLinkText,
  ExportDataButton,
  ExportIcon,
  ExportButtonandSettingIconPhone,
} from "../../../pages/Dashboard/Dashboard.styles";

import { colors } from "../../../theme/color";
import SearchBar from "../../../components/SearchBar/SearchBar";
import { LuCalendarDays } from "react-icons/lu";
import Table from "../../../pages/DashboardReturningUsers/TableReturningUsers/Table";
import {
  newTableHeaderData,
  tokenizeTableHeaderData,
} from "./TransactionTableData";
import { environment } from "../../../env";

import { useQuery } from "@apollo/client";
import ErrorPage from "../../ErrorComponent/ErrorPage";
import { GET_TOKENIZATION_BY_ORGANIZATION_ID } from "../../../graphql/queries/tokenization";

const TokenizationHistory = () => {
  const { loading, error, data } = useQuery(
    GET_TOKENIZATION_BY_ORGANIZATION_ID,
    {
      variables: {
        ...environment.paymentService,
        payload: {
          limit: 1000,
          page: 1,
        },
      },
    }
  );

  const [filteredTransactions, setFilteredTransactions] = useState([]);

  function handleSearch(searchItem: string): void {
    if (!searchItem || !data?.getAllOrganizationTokens?.data) {
      return;
    }
    const filteredData = data.getAllOrganizationTokens.data.filter(
      (transaction: any) => {
        if (
          transaction.updatedAt &&
          transaction.institutionName &&
          transaction.email &&
          typeof transaction.updatedAt === "string" &&
          typeof transaction.institutionName === "number" &&
          typeof transaction.email === "string"
        ) {
          return (
            transaction.updatedAt.includes(searchItem) ||
            transaction.institutionName.toString().includes(searchItem) ||
            transaction.email.includes(searchItem)
          );
        } else {
          return false;
        }
      }
    );

    setFilteredTransactions(filteredData || []);
  }

  const transaction = data?.getAllOrganizationTokens?.data || [];
  if (error)
    return (
      <>
        <ErrorPage />
      </>
    );
  if (loading) return <p>Loading...</p>;
  const maskValues = ["displayName", "email", "phoneNumber", "last4"];
  const handleCell = (value: any, key: any, obj: any) => {
    if (!maskValues.includes(key)) {
      return value;
    }
    const mask = "*".repeat(7);
    if (key === "email") {
      const [email, domail] = value?.toString?.()?.split?.("@");
      return email.slice(0, 3) + mask + "@" + domail;
    }
    if (key === "last4") {
      return mask + value;
    }
    return mask + value?.toString?.()?.slice?.(value?.length - 5);
  };
  return (
    <>
      <TitleContainer>
        <TitleTextHolder>
          <TitleText>Tokenization</TitleText>
          <SubtitleText>View all tokenized history</SubtitleText>
        </TitleTextHolder>
      </TitleContainer>
      <PaymentLinkContainer>
        <PaymentLinkHeader>
          <TitleSearchContainer>
            <PaymentLinkTitleText>Tokenized History</PaymentLinkTitleText>
            <SearchBar onSearch={handleSearch} />
          </TitleSearchContainer>
          <ExportButtonandSettingIconPhone>
            <ExportDataButton>
              <ExportIcon src="/assets/icons/export_icon.png" />
              <CalendarText>Export Data</CalendarText>
            </ExportDataButton>
          </ExportButtonandSettingIconPhone>
        </PaymentLinkHeader>
        <Table
          headData={tokenizeTableHeaderData}
          bodyData={transaction}
          status="transaction"
          useBodyArray={[...maskValues, "accountType"]}
          hideDate
          handleCell={handleCell}
        />
      </PaymentLinkContainer>
    </>
  );
};

export default TokenizationHistory;
